import client from "../client";
import { OrganizationType, PaginationRequest } from "src/types/commonTypes";
import internalClient from "../internalClient";

export interface ReportsRequest extends PaginationRequest {
  filter?: {
    report_filter?: {
      report_ids?: string[];
      report_types?: string[];
      report_date?: {
        min?: string;
        max?: string;
      };
    };
  };
}

export const getReport = (data: ReportsRequest) => {
  return client({
    query: `query SearchReport($input: SearchInput) {
        search_report(input: $input) {
            total_pages                
            total_size                
            reports {                    
                report_id             
                report_type  
                report_name          
                status    
                report_date                        
            }    
        }
    }`,
    variables: {
      input: data
    }
  });
};

export const getInternalReport = (data: ReportsRequest) => {
  return internalClient({
    query: `query InternalSearchReport($input: SearchInput) {
        internal_search_report(input: $input) {
            total_pages                
            total_size                
            reports {                    
                report_id             
                report_type  
                report_name          
                status    
                report_date
                created_by                        
            }    
        }
    }`,
    variables: {
      input: data
    }
  });
};

export const getOrganisationReport = (data: ReportsRequest) => {
  return client({
    query: `query SearchReport($input: SearchInput) {
        search_organisation_report(input: $input) {
            total_pages                
            total_size                
            reports {                    
                report_id             
                report_type  
                report_name          
                status    
                report_date                        
            }    
        }
    }`,
    variables: {
      input: data
    }
  });
};

export const getLicenceReport = (data: ReportsRequest) => {
  return client({
    query: `query SearchReport($input: SearchInput) {
        search_licence_report(input: $input) {
            total_pages                
            total_size                
            reports {                    
                report_id             
                report_type  
                report_name          
                status    
                report_date                        
            }    
        }
    }`,
    variables: {
      input: data
    }
  });
};

export const getWalletReport = (data: ReportsRequest) => {
  return client({
    query: `query SearchReport($input: SearchInput) {
        search_wallet_report(input: $input) {
            total_pages                
            total_size                
            reports {                    
                report_id             
                report_type  
                report_name          
                status    
                report_date                        
            }    
        }
    }`,
    variables: {
      input: data
    }
  });
};

export const getReportById = (report_id: string) => {
  return client({
    query: `query GetReport($input: GetReportInput) {
        get_report(input: $input) {
          report_id
          report_name
          report_date
          report_type
          status
          created_at    
        }
    }`,
    variables: {
      input: {
        report_id
      }
    }
  });
};

export interface ReportsContentRequest extends PaginationRequest {
  filter: {
    report_content_filter: {
      report_ids?: string[];
      object_ids?: string[];
      buckets?: string[];
      stages?: string[];
      organisation_id?: string;
      organisation_types?: OrganizationType[];
      report_types?: string[];
      report_date?: {
        min?: string;
        max?: string;
      };
      attributes?: {
        license_attributes?: {
          license_tag?: string;
          license_type?: string;
        };
      };
    };
  };
}

export const getReportContent = (data: ReportsContentRequest) => {
  return client({
    query: `query SearchReportContent($input: SearchInput) {
        search_report_content(input: $input) {
            total_pages                
            total_size                
            report_content_list {                    
                report_id
                report_date             
                report_content_id   
                report_type  
                object_id
                object_type
                data
            }    
        }
    }`,
    variables: {
      input: data
    }
  });
};

export interface DownloadReportRequest {
  report_id: string;
}

export const downloadReport = (data: DownloadReportRequest) => {
  return client({
    query: `query DownloadReport($input: GetReportDownloadUrlInput) {
        get_report_download_url(input: $input) {
            download_url
        }
    }`,
    variables: {
      input: data
    }
  });
};
